import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { ApiService }          from './api.service';
import { CacheService }        from './cache.service';
import { StreamSearchService } from './stream-search.service';

@NgModule({
  providers: [
    ApiService,
    CacheService,
    StreamSearchService
  ],
  schemas: [NO_ERRORS_SCHEMA],
})
export class ApiModule {}
